<template>
    <div class="dropdown-text" @click="redirect">
        <span>{{
                [
                    resource.title !== 'other' ? uLang(`app.${resource.title}`) : '',
                    resource.first_name,
                    resource.prefix,
                    resource.last_name
                ].join(' ')
            }}</span><br>
        <small>{{ resource.organisation ? resource.organisation.name : '-' }}</small>
    </div>
</template>

<script>
import globalSearch from "~/mixins/global-search";

export default {
    name: "relations-result.vue",
    mixins: [globalSearch],
}
</script>

<style scoped>

</style>
